import { createV3Queries } from "@query/utils/createV3Queries";
import { acknowledgementsApi } from "@api";

export const queriesAcknowledgements = createV3Queries(
  "acknowledgementsApi",
  acknowledgementsApi
);
